import {Controller, useFormContext} from 'react-hook-form';

import FormHelperText from '@mui/material/FormHelperText';

import {
  Upload,
  UploadBox,
  UploadProps,
  UploadAvatar,
  UploadPropslms
} from '../upload';
import UploadFiles from '@modules/home/main/modules-menu/course-catalog/ModulePageComponents/AdditionData/UploadFiles';

// ----------------------------------------------------------------------
interface progressBarData {
  id: string;
  progress: number;
  display: boolean;
}
interface Props extends Omit<UploadProps, 'file'> {
  name: string;
  multiple?: boolean;
  maxFiles?: number;
}
interface Propslms extends Omit<UploadPropslms, 'file'> {
  name: string;
  multiple?: boolean;
  maxFiles?: number;
}

// ----------------------------------------------------------------------

export function RHFUploadAvatar({name, ...other}: Props) {
  const {control} = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({field, fieldState: {error}}) => (
        <div>
          <UploadAvatar error={!!error} file={field.value} {...other} />

          {!!error && (
            <FormHelperText error sx={{px: 2, textAlign: 'center'}}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}

// ----------------------------------------------------------------------

export function RHFUploadBox({name, ...other}: Props) {
  const {control} = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({field, fieldState: {error}}) => (
        <UploadBox files={field.value} error={!!error} {...other} />
      )}
    />
  );
}

// ----------------------------------------------------------------------

export function RHFUpload({name, multiple, helperText, ...other}: Props) {
  const {control} = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({field, fieldState: {error}}) =>
        multiple ? (
          <Upload
            multiple
            accept={{'image/*': []}}
            files={field.value}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{px: 2}}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            {...other}
          />
        ) : (
          <Upload
            accept={{'image/*': []}}
            file={field.value}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{px: 2}}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            {...other}
          />
        )
      }
    />
  );
}
export function RHFSingleUpload({
  name,
  multiple,
  maxFiles,
  helperText,
  ...other
}: Propslms) {
  const {control} = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({field, fieldState: {error}}) => {
        return (
          <UploadFiles
            files={field.value}
            name={name}
            multiple={multiple}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{px: 2}}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            {...other}
          />
        );
      }}
    />
  );
}
export function RHFUploadCMS({name, multiple, helperText, ...other}: Props) {
  const {control} = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({field, fieldState: {error}}) => {
        return (
          <Upload
            multiple
            accept={{'image/*': []}}
            files={field.value}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{px: 2}}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            {...other}
          />
        );
      }}
    />
  );
}
